import { useSound as useSoundInternal } from 'use-sound';

import React from 'react';
import { useAudioContext, useVolume } from './AudioProvider';

interface UseSoundAdditionalOptions {
    loop?: boolean;
}

export const useSound: typeof useSoundInternal<UseSoundAdditionalOptions> = (src, options?) => {
    const audioAPI = useAudioContext();
    const volume = useVolume();

    const sound = useSoundInternal(src, {
        volume,
        ...options,
    });

    const controller = sound[1];

    React.useEffect(() => {
        if (controller.sound) {
            controller.sound.mute(audioAPI.muteSignal.value);
            audioAPI.muteSignal.listen((muted) => {
                controller.sound.mute(muted);
            });
        }
    }, [controller.sound]);

    return sound;
};
